module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "feedback-knowledge-js": "static-1.5174",
      "hs-test-utils": "static-1.7702",
      "I18n": "static-7.1549",
      "jasmine-runner": "static-1.6174",
      "quartz": "static-1.6605",
      "hubspot-url-utils": "static-1.3881",
      "outpost": "static-1.3929",
      "PatternValidationJS": "static-1.437",
      "react": "static-7.177",
      "moment": "static-3.26",
      "foundations-components": "static-1.7349",
      "framer-motion": "static-1.66",
      "hs-test-utils-bend-plugin": "static-1.2813",
      "msw": "static-1.39",
      "react-dom": "static-7.85",
      "react-redux": "static-7.66",
      "redux": "static-4.16",
      "testing-library": "static-1.146",
      "enviro": "static-4.392",
      "i18n-data": "static-1.215",
      "metrics-js": "static-1.9354",
      "moment-timezone": "static-5.77",
      "react-utils": "static-2.5101",
      "StyleGuideUI": "static-3.482",
      "jasmine": "static-4.4049",
      "quartz-config": "static-1.383",
      "history": "static-4.47",
      "webpack-env": "static-1.54",
      "quartz-core": "static-1.5824",
      "csstype": "static-1.50",
      "bend-plugin-foundations-components": "static-1.3618",
      "floating-ui": "static-1.50",
      "foundations-assets": "static-1.4550",
      "foundations-theming": "static-1.4122",
      "foundations-theming-specialty": "static-1.1838",
      "hs-story-utils": "static-1.9144",
      "react-aria": "static-1.60",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.93",
      "styled-components": "static-2.84",
      "tanstack-table": "static-1.49",
      "trellis-assets": "static-1.1004",
      "ui-fonts": "static-1.403",
      "ui-images": "static-2.1068",
      "bender-build-tools": "static-1.2832",
      "hoist-non-react-statics": "static-3.9",
      "dispatcher": "static-1.130",
      "general-store": "static-6.20",
      "HeadJS": "static-2.696",
      "hub-http": "static-1.5872",
      "hub-http-janus": "static-1.777",
      "hubspotter-http": "static-1.4404",
      "icons": "static-2.615",
      "mobile-manifest-mixins": "static-1.469",
      "PortalIdParser": "static-2.354",
      "quartz-auth": "static-1.280",
      "quartz-head": "static-1.270",
      "quartz-i18n": "static-1.280",
      "quartz-routing": "static-1.35",
      "quartz-test": "static-1.280",
      "quick-fetch": "static-1.3654",
      "raven": "static-3.5638",
      "raven-hubspot": "static-1.5945",
      "react-rhumb": "static-1.16351",
      "react-router-dom": "static-5.26",
      "usage-tracker-container": "static-1.7042",
      "UIComponents": "static-3.8088",
      "bend-plugin-foundations-theming": "static-1.2605",
      "foundations-theming-base": "static-1.3107",
      "stylex": "static-1.26",
      "react-input-autosize": "static-2.17",
      "classnames": "static-2.10",
      "sassPrefix": "static-1.150",
      "hub-http-shared-msw-handlers": "static-1.9262",
      "hubspotter-http-shared-msw-handlers": "static-1.9260",
      "hs-promise-rejection-tracking": "static-1.5303",
      "usage-tracker-core": "static-1.6902",
      "cssUtils": "static-1.708",
      "head-dlb": "static-1.4754",
      "HubStyle": "static-2.11449",
      "HubStyleTokens": "static-2.11141",
      "ts-schema": "static-1.3829"
    },
    "depPathPrefixes": {
      "feedback-knowledge-js": "/feedback-knowledge-js/static-1.5174",
      "hs-test-utils": "/hs-test-utils/static-1.7702",
      "I18n": "/I18n/static-7.1549",
      "jasmine-runner": "/jasmine-runner/static-1.6174",
      "quartz": "/quartz/static-1.6605",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3881",
      "outpost": "/outpost/static-1.3929",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react": "/react/static-7.177",
      "moment": "/moment/static-3.26",
      "foundations-components": "/foundations-components/static-1.7349",
      "framer-motion": "/framer-motion/static-1.66",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2813",
      "msw": "/msw/static-1.39",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.66",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.146",
      "enviro": "/enviro/static-4.392",
      "i18n-data": "/i18n-data/static-1.215",
      "metrics-js": "/metrics-js/static-1.9354",
      "moment-timezone": "/moment-timezone/static-5.77",
      "react-utils": "/react-utils/static-2.5101",
      "StyleGuideUI": "/StyleGuideUI/static-3.482",
      "jasmine": "/jasmine/static-4.4049",
      "quartz-config": "/quartz-config/static-1.383",
      "history": "/history/static-4.47",
      "webpack-env": "/webpack-env/static-1.54",
      "quartz-core": "/quartz-core/static-1.5824",
      "csstype": "/csstype/static-1.50",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3618",
      "floating-ui": "/floating-ui/static-1.50",
      "foundations-assets": "/foundations-assets/static-1.4550",
      "foundations-theming": "/foundations-theming/static-1.4122",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1838",
      "hs-story-utils": "/hs-story-utils/static-1.9144",
      "react-aria": "/react-aria/static-1.60",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.93",
      "styled-components": "/styled-components/static-2.84",
      "tanstack-table": "/tanstack-table/static-1.49",
      "trellis-assets": "/trellis-assets/static-1.1004",
      "ui-fonts": "/ui-fonts/static-1.403",
      "ui-images": "/ui-images/static-2.1068",
      "bender-build-tools": "/bender-build-tools/static-1.2832",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "dispatcher": "/dispatcher/static-1.130",
      "general-store": "/general-store/static-6.20",
      "HeadJS": "/HeadJS/static-2.696",
      "hub-http": "/hub-http/static-1.5872",
      "hub-http-janus": "/hub-http-janus/static-1.777",
      "hubspotter-http": "/hubspotter-http/static-1.4404",
      "icons": "/icons/static-2.615",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.469",
      "PortalIdParser": "/PortalIdParser/static-2.354",
      "quartz-auth": "/quartz-auth/static-1.280",
      "quartz-head": "/quartz-head/static-1.270",
      "quartz-i18n": "/quartz-i18n/static-1.280",
      "quartz-routing": "/quartz-routing/static-1.35",
      "quartz-test": "/quartz-test/static-1.280",
      "quick-fetch": "/quick-fetch/static-1.3654",
      "raven": "/raven/static-3.5638",
      "raven-hubspot": "/raven-hubspot/static-1.5945",
      "react-rhumb": "/react-rhumb/static-1.16351",
      "react-router-dom": "/react-router-dom/static-5.26",
      "usage-tracker-container": "/usage-tracker-container/static-1.7042",
      "UIComponents": "/UIComponents/static-3.8088",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2605",
      "foundations-theming-base": "/foundations-theming-base/static-1.3107",
      "stylex": "/stylex/static-1.26",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "classnames": "/classnames/static-2.10",
      "sassPrefix": "/sassPrefix/static-1.150",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9262",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9260",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5303",
      "usage-tracker-core": "/usage-tracker-core/static-1.6902",
      "cssUtils": "/cssUtils/static-1.708",
      "head-dlb": "/head-dlb/static-1.4754",
      "HubStyle": "/HubStyle/static-2.11449",
      "HubStyleTokens": "/HubStyleTokens/static-2.11141",
      "ts-schema": "/ts-schema/static-1.3829"
    },
    "project": "feedback-knowledge-js",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};